export enum Layer {
  CHAT = "CHAT",
  CHAT_SETTINGS = "CHAT_SETTINGS",
}
